export class DatePickerHarnessController {
  public date: Date;
  public currentDate: Date;
  public onDateChange: (params: any) => void = this.dateChanged;
  public lastClosed: Date;
  // @ngInject
  constructor(private $element: ng.IAugmentedJQuery) {
    this.date = new Date(2016, 0, 4);
  }

  public dateChanged(params: any) {
    alert("date changed to " + params);
  }

  public setCurrentDateAndIncrement(incrementInMs: number) {
    this.currentDate = this.currentDate ? new Date(this.currentDate.getTime() + incrementInMs) : new Date();
  }

  public pickerClosed() {
    this.lastClosed = new Date();
  }
}
